import { CreatePropertyContext } from "@/contexts"
import { useContext } from "react"

export const useCreatePropertyContext = () => {
  const context = useContext(CreatePropertyContext)

  if (!context) throw new Error('useCreatePropertyContext have to be wrapped by CreatePropertyContextPropvider')

  return context
}
